var _rect, _path, _rect2, _rect3, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptemberAiSupports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "Cryptember AI validation supports",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 124,
    height: 124,
    rx: 20,
    fill: "#171C21",
    stroke: "#34414B",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6B18",
    fillRule: "evenodd",
    d: "M14 100 44.5 24h15L90 100H73.5l-7-18H37.4l-7 18H14Zm28.7-32h18.5L52 43.8 42.7 68Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 50,
    width: 13,
    height: 50,
    fill: "#42D9E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 27,
    width: 13,
    height: 13,
    fill: "#42D9E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91 103 9 9 18-23",
    fill: "none",
    stroke: "#0B1014",
    strokeWidth: 12,
    strokeLinecap: "square",
    strokeLinejoin: "miter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m91 103 9 9 18-23",
    fill: "none",
    stroke: "#32B878",
    strokeWidth: 7,
    strokeLinecap: "square",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptemberAiSupports);
export default __webpack_public_path__ + "static/media/cryptember-ai-supports.b42e8cdfbf95d4289d4e4c4fd828f100.svg";
export { ForwardRef as ReactComponent };